/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    SAVE: 'Speichern',
    SUBMIT: 'Senden'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Fehler beim Abbrechen der Gegenleistung',
    COUNTERPART_DETAILS_SUBMIT: 'Fehler beim Senden der Gegenleistung',
    DELETE_ATTACHMENT: 'Fehler beim Löschen des Anhangs',
    DELETE_LINK: 'Fehler beim Löschen des Links',
    ERROR: 'Fehler',
    FILE_SIZE: 'Die Datei darf nicht größer als 8MB sein',
    MAX_FILES_UPLOAD: 'Du kannst nicht mehr als 8MB gleichzeitig hochladen',
    PUBLISHED_AT_ERROR: 'Veröffentlichungsdatum obligatorisch'
  },
  HEADER: {
    APPROVED_BY: 'Genehmigt von',
    ATTACHMENT: 'Anhänge',
    COMMENT: 'Kommentar',
    CONFIRMATION_DATE: 'Bestätigung',
    CURRENT_PARTNER_TASKS: 'Aktuelle/r Partner/in',
    DESCRIPTION: 'Beschreibung',
    END_DATE: 'Enddatum',
    LINK: 'Links',
    MANAGER_COMMENT: 'Kommentar des Managers',
    MONTH: 'Monat',
    PERIODICITY: 'Periodizität',
    PREVIOUS_PARTNER_TASKS: 'Vorherige/r Partner/in',
    REQUIRED: 'Erforderlich',
    START_DATE: 'Startdatum',
    STATE: 'Status',
    SUBMISSION_DATE: 'Einreichung'
  },
  LABEL: {
    ATTACHMENTS: 'Anhänge',
    ATTACHMENTS_UPLOADED: 'Anhänge hochgeladen',
    CANCEL_COUNTERPART: 'Abbrechen',
    CLOSE: 'Schließen',
    COMMENT: 'Kommentar',
    CONFIRM: 'Bestätigen',
    DESCRIPTION: 'Beschreibung',
    FILTER_MONTH_APR: 'April',
    FILTER_MONTH_AUG: 'August',
    FILTER_MONTH_DEC: 'Dezember',
    FILTER_MONTH_FEB: 'Februar',
    FILTER_MONTH_JAN: 'Januar',
    FILTER_MONTH_JUL: 'Juli',
    FILTER_MONTH_JUN: 'Juni',
    FILTER_MONTH_MAR: 'März',
    FILTER_MONTH_MAY: 'Mai',
    FILTER_MONTH_NOV: 'November',
    FILTER_MONTH_OCT: 'Oktober',
    FILTER_MONTH_SEP: 'September',
    LINK: 'Link',
    LINKS: 'Links',
    LINKS_UPLOADED: 'Links hochgeladen',
    MONTH: 'Monat',
    PUBLISHED_AT: 'Veröffentlichungsdatum',
    STATE: 'Status',
    SUBMIT_COUNTERPART: 'Senden',
    YEAR: 'Jahr'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Möchtest du das Senden der Gegenleistung wirklich abbrechen?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Möchtest du die Gegenleistung wirklich senden?',
    NO_ROWS_ATTACHMENT: 'Keine Anhänge'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Anhang gelöscht',
    CANCEL_COUNTERPART: 'Gegenleistung abgebrochen',
    COUNTERPART_DETAILS_SUBMIT:
      'Die Details der Gegenleistung wurden erfolgreich gesendet',
    LINK_DELETED: 'Link gelöscht',
    SUCCESS: 'Erfolg'
  },
  TOOLTIP: {
    ADD_LINK: 'Link hinzufügen',
    APPROVED_BY: 'Genehmigt von',
    ATTACHMENT: 'Anhänge',
    COMMENT: 'Kommentar',
    CONFIRMATION_DATE: 'Bestätigungsdatum',
    CURRENT_PARTNER_TASKS:
      'Anzahl der vom/von der Partner/in einzureichenden Register des aktuellen Zeitraums',
    DESCRIPTION: 'Beschreibung',
    END_DATE: 'Enddatum',
    LINK: 'Links',
    MANAGER_COMMENT: 'Kommentar des Managers',
    MONTH: 'Monat',
    PERIODICITY: 'Periodizität',
    PREVIOUS_PARTNER_TASKS:
      'Anzahl der vom/von der Partner/in einzureichenden Register des vorherigen Zeitraums',
    REMOVE_LINK: 'Link entfernen',
    REQUIRED: 'Erforderlich',
    START_DATE: 'Startdatum',
    STATE: 'Status',
    SUBMISSION_DATE: 'Sendedatum'
  }
};
